import React, { useState } from "react";
import PopupBase from "../base/PopupBase";
import { DataProviderInstance } from '../../api/DataProvider';
import CustomButton from "../../components/buttons/CustomButton";
import styles from './styles.module.css';
import CircleIcon from '../../components/circleIcon/CircleIcon';
import Icon from "@mui/icons-material/CheckCircle";
import Alert from '@mui/material/Alert';
import AreaTitle from "../../components/areaTitle/AreaTitle";

function AppointmentDoneConfirmPopupContent(props) {
    const
        {
            CompanyConfig,
        } = DataProviderInstance();

    const { OnSave, OnHide, Data } = props;

    // Queixa e evolução só são obrigatórias quando o tipo de atendimento tem o módulo
    const requiresEvolution = Data.requiresEvolution !== false;

    function OnCloseClickHandler() {
        Hide();
    }

    function OnCancelClickHandler() {
        Hide();
    }

    function OnConfirmClickHandler() {
        OnSave();
        Hide();
    }

    function Hide() {
        OnHide();
    }

    function GetTitle() {

        return "Confirme os dados do seu atendimento";
    }

    function CheckEvolutions() {

    }

    function GetContent() {
        const appointmentDate = new Date(Data.appointment.date);
        const formattedStartDate = `${appointmentDate.getDate().toString().padStart(2, '0')}/${(appointmentDate.getMonth() + 1).toString().padStart(2, '0')}/${appointmentDate.getFullYear()}`;

        // Duração pelo cronômetro e, se o início foi guardado, o horário real (sem segundos).
        // Só exibição: o que vai para o prontuário não depende destes valores.
        const durationText = 'Duração: ' + FormatDuration(Data.duration);
        const periodText = Data.startedAt
            ? ' · das ' + FormatClock(new Date(Data.startedAt)) + ' às ' + FormatClock(new Date(Data.startedAt + Data.duration * 1000))
            : '';

        return (

            <div className={styles.container}>
                <div className={styles.containerInfos}>
                    <AreaTitle Icon={<Icon />} Title={Data.patient.name} Description={'Data: ' + formattedStartDate + '\n' + durationText + periodText} />

                    {requiresEvolution && (
                        <div className={styles.containerEvolution}>
                            <div className={styles.containerEvolutionItem}>
                                <h4>Queixa:</h4>
                                <p>{Data.todayAssessment}</p>
                            </div>
                            <div className={styles.containerEvolutionItem}>
                                <h4>Evolução:</h4>
                                <p> {Data.todayEvolution}</p>
                            </div>
                        </div>
                    )}

                    {!CheckCanRegister() && <Alert severity="error">{GetMissingMessage()}</Alert>}

                </div>
            </div>
        );
    }


    function FormatClock(date) {
        return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    }

    function FormatDuration(seconds) {
        const totalMinutes = Math.floor((seconds || 0) / 60);
        if (totalMinutes < 1) {
            return 'menos de 1 min';
        }
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (hours === 0) {
            return `${minutes} min`;
        }
        return minutes === 0 ? `${hours} h` : `${hours} h ${minutes.toString().padStart(2, '0')} min`;
    }

    // Diz qual campo falta, em vez de pedir os dois quando só um está vazio
    function GetMissingMessage() {
        const missing = [];
        if (Data.todayAssessment == "") missing.push('a queixa');
        if (Data.todayEvolution == "") missing.push('a evolução');
        return 'Falta preencher ' + missing.join(' e ') + ' do paciente no card Registro de Atendimento.';
    }

    function CheckCanRegister() {
        if (!requiresEvolution) {
            return true;
        }
        return Data.todayAssessment != "" && Data.todayEvolution != "";
    }

    function GetFooter() {
        return (
            <div className={styles.footer}>
                <CustomButton variant="outlined" style="secondary" label={"Cancelar"} onClick={OnCancelClickHandler} />
                <CustomButton style="primary" variant="contained" label={"Registrar"} onClick={OnConfirmClickHandler} enabled={CheckCanRegister()} data-tour="appointment-register-confirm" />
            </div>
        )
    }

    function GetRender() {

        return <PopupBase Title={GetTitle()} Content={GetContent()} Footer={GetFooter()} OnClose={OnCloseClickHandler} />
    }

    return (GetRender());
}

export default AppointmentDoneConfirmPopupContent;